import React, { useEffect, useState, useRef } from 'react'

import successIcon from 'assets/img/success_icon.png'
// imgs
import { withTranslation } from 'react-i18next'

import { useLocation } from 'react-router-dom'
import { Box, Grid, Typography } from '@mui/material'
import {
	hideOnEcommerce,
	history,
	isEcommerce,
	mockUrlEcommerceLogin,
} from '../../utils'
import {
	GetThemeFromAPI,
	GetThemeFromAPILogin,
} from '../../redux/api/themeColor'
import Button from 'components/CustomButtons/Button.jsx'
import { envs } from '../../redux/api/windowServerData'
import SupportFooter from '../SimplifiedRegistration/template/components/SupportFooter'
import { GetContact } from '../../redux/api/footer'
import Header from '../SimplifiedRegistration/template/components/Header'
import Loader from 'components/Loader/Loader.jsx'
import { GetGeneralRulesData } from '../../redux/api/generalRules'

function SuccessScreen({ t }) {
	const location = useLocation()
	const [contact, setContat] = useState()
	const [themeColor, setThemeColor] = useState()
	const [generalRules, setGeneralRules] = useState()
	const [loading, setLoading] = useState(true)
	const containerRef = useRef(null)

	const getTheme = async () => {
		try {
			const response = await GetThemeFromAPI()
			console.log('response theme', response)

			if (response?.data) {
				setThemeColor(response.data)
			}
		} catch (error) {
			console.log('Error fetching theme:', error)
		}
	}

	const getInitialData = async () => {
		setLoading(true)

		try {
			await getTheme()
			const [generalRules, contact] = await Promise.all([
				GetGeneralRulesData(),
				GetContact(),
			])

			contact && setContat(contact)
			generalRules && setGeneralRules(generalRules)
		} catch (error) {
			console.error('Erro ao buscar dados iniciais:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		getInitialData()
	}, [])

	return (
		<Box ref={containerRef} height={isEcommerce ? 'auto' : '100vh'} overflow={isEcommerce ? 'unset' : 'hidden'}>
			{loading && <Loader />}
			<Grid container height={'100%'}>
				<Grid
					item
					xs={12}
					sm={12}
					display={isEcommerce && 'flex'}
					md={isEcommerce ? 12 : 8}
					alignItems={isEcommerce ? 'center' : 'flex-start'}
					justifyContent="center"
					sx={{ overflowY: isEcommerce ? 'unset' : 'auto', height: isEcommerce ? 'auto' : '100vh' }}
				>
					{hideOnEcommerce(
						<Header
							history={history}
							themeColor={themeColor}
							isOptions={false}
						/>,
					)}
					<Box
						display="flex"
						flexDirection="column"
						gap="25px"
						mt="90px"
					>
						<Box
							display="flex"
							alignItems="center"
							gap="25px"
							flexDirection="column"
						>
							<Box
								component="img"
								src={successIcon}
								alt="SUCCESS"
								sx={{ width: '81px' }}
							/>
							<Typography
								variant="body1"
								fontSize="20px"
								sx={{ fontWeight: '700', textAlign: 'center' }}
							>
								{t('activationCode - SUCCESS')}
							</Typography>
						</Box>
						<Box
							display="flex"
							alignItems="center"
							gap="25px"
							flexDirection="column"
						>
							<Typography
								variant="body1"
								sx={{ fontWeight: '700', textAlign: 'center' }}
							>
								Com a mesma senha e login, você acessa a sua
								conta e também a loja virtual <br /> do{' '}
								{generalRules?.name ?? ''}.
							</Typography>
							<Typography
								variant="body2"
								textAlign="center"
								sx={{
									font: 'normal normal normal 14px/26px Roboto',
								}}
							>
								Comece a acumular Pontos, sua nova moeda virtual
								no mundo de vantagens do programa. <br />
								Suas compras poderão acumular pontos e com eles
								trocar por diversos produtos.
							</Typography>
						</Box>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							gap="15px"
							mt="30px"
							flexDirection={{
								xs: 'column',
								sm: 'row',
								md: 'row',
								lg: 'row',
							}}
						>
							<Button
								size="sm"
								defaultTheme={themeColor}
								color="greenButtonColor"
								onClick={() => {
									if (isEcommerce) {
										window.parent.postMessage(
											{
												action: 'redirect',
												url: mockUrlEcommerceLogin,
											},
											'*',
										)
										return
									}
									history.push('/auth/login')
								}}
								style={{ width: '195px', borderRadius: '6px' }}
							>
								{t('BUTTON_ACCESS_ACCOUNT')}
							</Button>
							{hideOnEcommerce(
								<Button
									defaultTheme={themeColor}
									color="greenButtonColor"
									style={{
										width: '195px',
										borderRadius: '6px',
									}}
									size="sm"
									onClick={() =>
										window.open(
											envs.REACT_APP_MAGENTO_URL ?? '',
											'_blank',
										)
									}
								>
									{t('BUTTON_ACCESS_STORE')}
								</Button>,
							)}
						</Box>
					</Box>
				</Grid>
				{hideOnEcommerce(
					<Grid item xs={12} sm={12} md={4}>
						<Box height="100vh" overflow="hidden">
							<SupportFooter t={t} contact={contact} />
						</Box>
					</Grid>,
				)}
			</Grid>
		</Box>
	)
}

export default withTranslation()(SuccessScreen)
